package com.schoolconnect.app.feature.splash

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun SplashFeatureRoute() {
    val viewModel = remember { SplashViewModel() }
    val uiState by viewModel.uiState.collectAsState()

    SplashScreen(state = uiState)
}
